<template>
  <div class="general-loader-wrapper" :class="wrapperClass">
    <div class="card">
      <div class="card-body d-flex align-items-center justify-content-center">
        <spinner :show="loading" spinner-size="4" :font-size="1.2"/>
      </div>
    </div>
  </div>
</template>

<script>
  import Spinner from "@/core/components/common/Spinner";

  export default {
    name: "GeneralLoader",
    components: {Spinner},
    props: {
      loading: {
        type: Boolean,
        default: false
      },
      wrapperClass: {
        type: String,
        default: "bg-secondary h-100 p-3"
      }
    }
  }
</script>

<style lang="scss" scoped>
  .general-loader-wrapper {
    .card-body {
      height: 25em !important;
    }
  }
</style>
